import {Component, ViewChild} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Router, RouterModule} from '@angular/router';
import {TopBarComponent} from '../top-bar/top-bar.component';
import {User} from '../../models/users';
import {SharedDataService} from '../../services/shared-data.service';
import {FooterComponent} from '../footer/footer.component';
import {DashboardCapacityComponent} from '../dashboard-capacity/dashboard-capacity.component';

@Component({
  selector: 'app-layout',
  imports: [
    CommonModule,
    RouterModule,
    DashboardCapacityComponent,
  ],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss',
  standalone: true,
})
export class LayoutComponent {

  user: User | null = null;
  menuOutsideClickListener: any;

  @ViewChild(FooterComponent) footer!: FooterComponent;
  @ViewChild(TopBarComponent) appTopBar!: TopBarComponent;

  constructor(
    public router: Router,
    private sharedDataService: SharedDataService
  ) {

  }

  ngOnInit(): void {
    // Get the agent object from the shared data service
    this.user = this.sharedDataService.getAgent();

    if (!this.user) {
      // console.warn('No agent data found in localStorage. Redirecting to login page...');
      this.router.navigate(['/login']); // Redirect to login if no agent
    } else {
      //console.log('Agent data loaded in LayoutComponent:', this.user);
    }
  }

  isOutsideClicked(event: MouseEvent) {
    const sidebarEl = document.querySelector('.layout-sidebar');
    const topbarEl = document.querySelector('.layout-menu-button');
    const eventTarget = event.target as Node;

    return !(sidebarEl?.isSameNode(eventTarget) || sidebarEl?.contains(eventTarget) || topbarEl?.isSameNode(eventTarget) || topbarEl?.contains(eventTarget));
  }

  unblockBodyScroll(): void {
    if (document.body.classList) {
      document.body.classList.remove('blocked-scroll');
    } else {
      document.body.className = document.body.className.replace(new RegExp('(^|\\b)' + 'blocked-scroll'.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
    }
  }

  ngOnDestroy() {
    // if (this.overlayMenuOpenSubscription) {
    //   this.overlayMenuOpenSubscription.unsubscribe();
    // }

    if (this.menuOutsideClickListener) {
      this.menuOutsideClickListener();
    }
  }
}
